module.exports = __webpack_public_path__ + "img/ex2.ab044f70.png";